var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8610_254129)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_8610_254129)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8610_254129)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3163 51.0834C44.8208 51.0834 51.7151 44.189 51.7151 35.6845C51.7151 27.18 44.8208 20.2856 36.3163 20.2856C27.8118 20.2856 20.9175 27.18 20.9175 35.6845C20.9175 37.429 21.2076 39.1057 21.7421 40.669C22.0859 41.6746 22.1592 42.7688 21.796 43.7675L20.5779 47.1172C19.7935 49.2745 19.4012 50.3531 19.6434 51.056C19.8538 51.6669 20.3339 52.1469 20.9448 52.3575C21.6477 52.5995 22.7263 52.2072 24.8835 51.4229L28.2329 50.2048C29.2318 49.8416 30.3261 49.9149 31.3318 50.2588C32.8951 50.7933 34.5719 51.0834 36.3163 51.0834Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8610_254129",
    x1: 0,
    y1: 0,
    x2: 72,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8610_254129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8610_254129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0ed693dd.svg";
export { ForwardRef as ReactComponent };